export default {"src":"/_next/static/media/LifeThreateningInfections.ac45066f.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};